/* eslint-disable */
import React from 'react'

class HeaderTablePrint extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount() {}

  render() {
    return (
      <thead>
        <tr>
          <td className="centerHeader" colSpan={this.props.headerColSpan}>
            <h3 style={{fontWeight: '900'}}>{this.props.header}</h3>
          </td>
        </tr>
        <tr>
          <td colSpan={this.props.rightColSpan} className="rightHeader">
            <p style={{fontWeight: '600'}}>{this.props.rightSection}</p>
            <p style={{visibility: 'hidden'}}>-</p>
          </td>
          <td colSpan={this.props.centerColSpan} className="centerHeader">
            <p style={{fontWeight: '600'}}>{this.props.centerSection}</p>
            <p style={{visibility: 'hidden'}}>-</p>
          </td>
          <td colSpan={this.props.leftColSpan} className="leftHeader">
            <p style={{fontWeight: '600'}}>{'گزارش گیرنده : ' + this.props.reporter}</p>
            <p style={{fontWeight: '600'}}>{'تاریخ گزارش گیری : ' + this.props.timePrint}</p>
          </td>
        </tr>
        <tr id="firstRowPrint">
          {this.props.columns.map((col, index) => (
            <td className="borderHeader">{col}</td>
          ))}
        </tr>
      </thead>
    )
  }
}
export default HeaderTablePrint
